// Module
var code = "<div class=\"hbox hbox-auto-xs hbox-auto-sm bg-light\">\n\n    <div class=\"col w-xl lter b-r\" ui-view=\"supportList\"></div>\n    \n    <div class=\"col bg-white-only\" ui-view=\"supportView\"></div>\n</div>\n";
// Exports
module.exports = code;